var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "AddUser",
        "hide-footer": "",
        title: _vm.edit ? _vm.$t("users.editUser") : _vm.$t("users.addUser")
      },
      on: {
        keyup: function($event) {
          if (
            !("button" in $event) &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          _vm.edit ? _vm.editUser() : _vm.addUser()
        }
      }
    },
    [
      _c(
        "b-form",
        [
          _c("bigCheck", { staticClass: "pt-4", attrs: { state: _vm.state } }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.state === "unloaded",
                  expression: "state==='unloaded'"
                }
              ]
            },
            [
              _c("v-field", {
                ref: "email",
                attrs: {
                  field: "email",
                  label: _vm.$t("login.email"),
                  type: "email",
                  msg: _vm.errorMsgs,
                  val: _vm.edit ? _vm.user.email : ""
                }
              }),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.edit,
                          expression: "!edit"
                        }
                      ],
                      attrs: { lg: "6" }
                    },
                    [
                      _c("v-field", {
                        ref: "password",
                        attrs: {
                          field: "password",
                          label: _vm.$t("login.password"),
                          type: "password",
                          msg: _vm.errorMsgs
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.edit,
                          expression: "!edit"
                        }
                      ],
                      attrs: { lg: "6" }
                    },
                    [
                      _c("v-field", {
                        ref: "password2",
                        attrs: {
                          field: "password2",
                          label: _vm.$t("login.rep_newpass"),
                          type: "password",
                          msg: _vm.errorMsgs
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _c("v-field", {
                        ref: "first_name",
                        attrs: {
                          field: "first_name",
                          label: _vm.$t("labels.firstName"),
                          type: "text",
                          msg: _vm.errorMsgs,
                          val: _vm.edit ? _vm.user.first_name : ""
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { lg: "6" } },
                    [
                      _c("v-field", {
                        ref: "last_name",
                        attrs: {
                          field: "last_name",
                          label: _vm.$t("labels.lastName"),
                          type: "text",
                          msg: _vm.errorMsgs,
                          val: _vm.edit ? _vm.user.last_name : ""
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-field", {
                ref: "is_active",
                attrs: {
                  field: "is_active",
                  label: _vm.$t("labels.isActive"),
                  type: "checkbox",
                  msg: _vm.errorMsgs,
                  val: _vm.edit ? _vm.user.is_active : false
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [
                    _vm._v(_vm._s(_vm.$t("labels.typeUser")) + ":")
                  ]),
                  _vm._v(" "),
                  _c("Multiselect", {
                    attrs: {
                      options: _vm.groupOptions,
                      "track-by": "id",
                      multiple: true,
                      preselectFirst: true,
                      label: "name"
                    },
                    model: {
                      value: _vm.groupSelected,
                      callback: function($$v) {
                        _vm.groupSelected = $$v
                      },
                      expression: "groupSelected"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "p",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.getErrors("non_field_errors") !== "",
                      expression: "getErrors('non_field_errors')!==''"
                    }
                  ],
                  staticClass: "alert alert-danger feedback-message"
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.getErrors("non_field_errors")) +
                      "\n        "
                  )
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-right mt-2",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    variant:
                      this.state === "unloaded" ? "outline-primary" : "primary"
                  },
                  on: { click: _vm.clear }
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.$t("users.saveUserOther")) +
                      "\n          "
                  )
                ]
              ),
              _vm._v(" "),
              this.state === "unloaded"
                ? _c(
                    "b-btn",
                    {
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          _vm.edit ? _vm.editUser() : _vm.addUser()
                        }
                      }
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("users.saveUser"))),
                        _c("i", { staticClass: "fa fa-check" })
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Users/UserForm.vue?vue&type=template&id=71233e1e&
// module id = null
// module chunks = 